'use strict';

var React = require('react');
var text = require('../../../helpers/text.js');

const useSearch = ({ labelFromValue, placeholder, search = null, onSearchChange, isOpened, }) => {
    const startSearching = React.useCallback(() => onSearchChange?.(''), [onSearchChange]);
    const endSearching = React.useCallback(() => onSearchChange?.(null), [onSearchChange]);
    const isSearching = text.isString(search);
    const getInputPlaceholder = () => {
        if (isSearching)
            return labelFromValue || placeholder;
        else
            return placeholder;
    };
    const getInputValue = () => {
        if (isSearching)
            return search ?? '';
        else
            return labelFromValue ?? '';
    };
    React.useEffect(() => {
        isOpened ? startSearching() : endSearching();
    }, [isOpened, startSearching, endSearching]);
    const input = {
        value: getInputValue(),
        placeholder: getInputPlaceholder(),
    };
    return input;
};

exports.useSearch = useSearch;
//# sourceMappingURL=useSearch.js.map
